import { authHeader } from "@roman/shared/lib/auth/authHeader";
import romanApi, { type RomanApiError } from "@roman/shared/lib/net/romanApi";
import useSWRMutation, { type SWRMutationConfiguration } from "swr/mutation";

type CreatePredictionMarketEntryInput = {
  predictionMarketId: string;
  predictionMarketChoiceId: string;
  freePoints: string;
};

const fetcher = async (url: string, { arg }: { arg: CreatePredictionMarketEntryInput }): Promise<void> => {
  const headers = authHeader.getOrThrow();
  await romanApi.post(url, arg, { headers });
};

export const useCreatePredictionMarketEntry = (
  swrOptions?: SWRMutationConfiguration<void, RomanApiError, string, CreatePredictionMarketEntryInput>,
) => {
  const { trigger, error, isMutating } = useSWRMutation<void, RomanApiError, string, CreatePredictionMarketEntryInput>(
    "/prediction-market/entries",
    fetcher,
    swrOptions,
  );

  return {
    createEntry: trigger,
    isMutating,
    error,
  };
};
